import React, { Fragment, useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
// hooks
import useMenuItems from "@/hooks/useMenuItems";
// components
import RMDRLink from "@/components/RMDRLink";
// utilities
import { 
    menuNameDescriptionLanguageVersion, 
    metaDataLanguageVersion,
    redirectUrl 
} from "@/utilities/LanguageVersionSelectorShortcut";
import MenuComposer from "@/utilities/MenuComposer";
// types
import { TMainPageLayoutV3 } from "../type";
import TMenu from "@/cms/types/TMenu";
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";


type TMenuItem = {
    payload:TMenu[];
    webApplicationLanguageISOCode:string;
    toggleNavbar: () => void;
}

const MenuItem = ( props:TMenuItem ) => {
    const location = useLocation();

    return (
        <>
            {
                props.payload?.map((item, index) => {
                    const languageVersion = menuNameDescriptionLanguageVersion(item.languageVersions);
                    if ( !languageVersion ) return null;
                    let _redirectUrl = redirectUrl(item.languageVersions)?.value;

                    if ( item.layouts?.[0]?.layoutName === "MN_001" ) _redirectUrl = `/${props.webApplicationLanguageISOCode}`;
                    else if ( item.layouts?.[0]?.layoutName === "MN_002" ) {
                        const redirectPath = metaDataLanguageVersion("redirectPath", item.languageVersions);
                        const redirectUrl = metaDataLanguageVersion("redirectUrl", item.languageVersions);
                        if ( redirectPath ) _redirectUrl = `/${props.webApplicationLanguageISOCode}${redirectPath}`;
                        else if ( redirectUrl ) _redirectUrl = redirectUrl;
                    }
                    
                    return (
                        <li key={item.id} className="nav-item">
                            <RMDRLink
                                text={languageVersion?.name}
                                hasNavigationDestination={item.hasDestinationNavigation}
                                navigationURL={languageVersion?.contentRouteNavigationURL}
                                redirectType={item.redirectType}
                                redirectUrl={_redirectUrl}
                                isShowAlways={true}
                                variant="div"
                                className={clsx("nav-link cursor-pointer", { "active":location.pathname === languageVersion.contentRouteNavigationURL })}
                                onClick={() => { if (item.hasDestinationNavigation) props.toggleNavbar()}}
                            >
                                {languageVersion?.name} 
                                {
                                    item.items && item.items.length > 0 && (<i className="fa-solid fa-angle-down"></i>)
                                }
                            </RMDRLink>
                            {
                                item.items && item.items.length > 0 && (<ul className="dropdown-menu"><MenuItem payload={item.items} webApplicationLanguageISOCode={props.webApplicationLanguageISOCode} toggleNavbar={props.toggleNavbar} /></ul>)
                            }
                        </li>
                    )
                })
            }
        </>
    )

}

const Menu = ( props:{payload:TMenu[], webApplicationLanguageISOCode:string} ) => {
    const [menu, setMenu] = useState<boolean>(true);

    useEffect(
        () => {
            const elementId = document.getElementById("navbar");
            document.addEventListener("scroll", () => {
                if (window.scrollY > 170) {
                    elementId?.classList.add("is-sticky");
                } else {
                    elementId?.classList.remove("is-sticky");
                }
            });
        }, []
    )

    const toggleNavbar = () => { setMenu(!menu) }
    const classOne = menu
        ? "collapse navbar-collapse"
        : "collapse navbar-collapse show";
    const classTwo = menu
        ? "navbar-toggler navbar-toggler-right collapsed"
        : "navbar-toggler navbar-toggler-right";

    return (
        <>
            <button
                onClick={toggleNavbar}
                className={classTwo}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
            </button>

            <div className={classOne} id="navbarSupportedContent">
                <ul className="navbar-nav">
                    <MenuItem payload={props.payload} webApplicationLanguageISOCode={props.webApplicationLanguageISOCode} toggleNavbar={toggleNavbar} />
                </ul>
            </div>
        </>
    )
}

const Render = ( props:{ menuItems:TClientMenuItemList[] } ) => {
    
    const webApplicationLanguageISOCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);
    let parentMenuItems = props.menuItems.filter((item:any) => item.parentId === null);
    let navigation = MenuComposer(props.menuItems, parentMenuItems);
    
    if ( !navigation ) return null;

    return (
        <Menu payload={navigation} webApplicationLanguageISOCode={webApplicationLanguageISOCode} />
    )

}

const RenderOwnContent = ( props:{unqKey:string, contentLayoutName:string} ) => {
    
    const menuItems = useMenuItems(props.unqKey, props.contentLayoutName);

    if ( !menuItems ) return null;

    return <Render menuItems={menuItems} />

}
const MNPG049 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG049.rendered: ", props);

    if ( !props.template ) return null;

    const unqKey = props.template.id.split("-")[4];
    return <RenderOwnContent unqKey={unqKey} contentLayoutName={props.template.contentLayoutName} />
}

export default MNPG049;
